import { render, staticRenderFns } from "./Counters.vue?vue&type=template&id=7b256b8e"
import script from "./Counters.vue?vue&type=script&lang=ts"
export * from "./Counters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports